import React from "react";
import { IonButton, IonTextarea } from "@ionic/react";
import { SubmitHandler, useForm } from "react-hook-form";
import { ControlledInput } from "../../components/ControlledInput";
import classNames from "classnames";
import { ErrorLabel } from "../../components/ErrorLabel";
import { InputWrapper } from "../../components/InputWrapper";
import { RouteComponentProps } from "react-router-dom";
import { addRecipeFeedback } from "../../firebase";
import "./RecipeFeedback.scss";
import { openToast } from "../../store/toastSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Timestamp } from "firebase/firestore";
import moment from "moment/moment";
import { selectUser } from "../../store/authSlice";

export const RecipeFeedback: React.FC<RouteComponentProps<{ id: string }>> = ({ match }) => {
    const user = useSelector(selectUser)!;
    const dispatch = useDispatch();
    const router = useHistory();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            subject: "",
            description: "",
        },
    });
    const onSubmit: SubmitHandler<any> = async (data) => {
        await addRecipeFeedback({
            ...data,
            recipeId: match.params.id,
            userId: user.id,
            userName: user.name,
            userRole: user.role,
            date: new Timestamp(moment().unix(), 0),
        });
        dispatch(openToast("Dziękujemy za przesłanie błędu w przepisie!"));
        router.goBack();
    };

    return (
        <div className="feedback-component">
            <div className="form-content">
                <form
                    noValidate={true}
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <p>
                        Znalazłeś błąd w przepisie, np. nie zgadzają się jednostki lub brakuje składnika? Prosimy, daj nam znać!
                    </p>
                    <ControlledInput
                        name="subject"
                        label="Temat"
                        register={register}
                        validationRules={{ required: true }}
                        errors={errors}
                    />
                    <InputWrapper
                        key="description"
                        className={classNames("description", {
                            "ion-valid": !errors.description?.type,
                            "ion-invalid": !!errors.description?.type,
                        })}
                    >
                        <IonTextarea
                            fill="outline"
                            labelPlacement="stacked"
                            label="Opis"
                            autoGrow={true}
                            errorText={errors.description?.type}
                            {...register("description", { required: true })}
                        />
                        <ErrorLabel>{errors.description?.type}</ErrorLabel>
                    </InputWrapper>
                    <div className="form-content"></div>
                    <IonButton
                        type="submit"
                        expand="block"
                    >
                        Wyślij
                    </IonButton>
                </form>
            </div>
        </div>
    );
};
